<template>
  <div class="gray-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected" @click="open = !open" :class="{ open: open }">
      <div>
        Выводить по:
        <b>
          {{ selected }}
        </b>
      </div>
      <img src="@/assets/img/main/open.svg" alt="">
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
          v-for="(option, i) of options"
          :key="i"
          @click="emit(option)"
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-grey-select",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      default: '',
    },
    tabindex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selected: this.value
          ? this.value
          : this.options.length > 0
              ? this.options[0]
              : null,
      open: false
    };
  },
  methods:{
    emit(d){
      this.selected = d;
      this.open = false;
      this.$emit('input', d);
    }
  },
  watch: {
    value(n){
      this.selected= n ? n : this.options.length > 0 ? this.options[0] : null
    }
  }
}
</script>

<style scoped>
b {
  color: #000;
}
.gray-select {

  position: relative;
  width: 100%;
  text-align: left;
  outline: none;

}

.gray-select .selected{
  border-radius: 4px;
  color: #7A818F;
  background-color: #EEF0F3;
  display: flex;
  align-items: center;
  height: 40px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  padding: 0 15px

}

.gray-select .selected img {
  margin-left: 5px;
}

.gray-select .selected.open {
  border: 1px solid #2CB181;
  padding: 0 14px;
  border-radius: 6px 6px 0px 0px;
}


.gray-select .items {
  top: 39px;
  color: #7A818F;
  border-radius: 0px 0px 6px 6px;
  overflow: hidden;
  border-right: 1px solid #2CB181;
  border-left: 1px solid #2CB181;
  border-bottom: 1px solid #2CB181;
  position: absolute;
  background-color: #EEF0F3;
  left: 0;
  right: 0;
  z-index: 500;
}

.gray-select .items div {
  color:#7A818F;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
  background-color: #EEF0F3;
}

.gray-select .items div:hover {
  background-color: #ced0d2;
}

.selectHide {
  display: none;
}
</style>